






























































import Vue from 'vue';
import { VueEditor } from 'vue2-editor';
import VatsAPI from '@/Shared/VatsAPI';
import ValidationErrorDirective from '@/Shared/ValidationErrorDirective';
import ReleaseNote from './ReleaseNote';
import {Dictionary} from 'vue-router/types/router';

const ReleaseNoteAdmin = Vue.extend({
    props: ['location'],
    components: {
        VueEditor
    },
    data() {
        return {
            form: new ReleaseNote(),
            loading: false,
            NoteDescription: '',
            LongFormText: '',
            ShortFormText: '',
            validationErrors: {} as Dictionary<string[]>
        };
    },
    directives: {
        ValidationErrorDirective
    },
    methods: {
        async sendEmail() {
            this.loading = true;
            await VatsAPI.post('releaseNotes/send');

            this.loading = false;
        },
        async saveNotes() {
            this.loading = true;
            try {
                // TODO: update validation directive to make this unnecessary
                this.form.NoteDescription = this.NoteDescription;
                this.form.LongFormText = this.LongFormText;
                this.form.ShortFormText = this.ShortFormText;

                await VatsAPI.post('ReleaseNotes/Add', this.form);
            }
            catch (e) {
                if (!e.response || e.response.status !== 400 || !e.response.data) {
                    return;
                }

                this.validationErrors = e.response.data.errors;
            }
            finally {
                this.loading = false;
            }
        }
    }
});

export default ReleaseNoteAdmin;
